import * as React from "react";
import { Slot } from "@radix-ui/react-slot";
import { cva, type VariantProps } from "class-variance-authority";
import { cn } from "../util";

/* Esquinas rectas; el naranja solo en la variante "acento" (el CTA único de la pantalla). */
const variantes = cva(
  "inline-flex items-center justify-center gap-2 whitespace-nowrap font-ui font-semibold text-sm leading-none transition-colors duration-150 disabled:pointer-events-none disabled:opacity-50 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 focus-visible:ring-offset-fondo [&_svg]:size-4 [&_svg]:shrink-0",
  {
    variants: {
      variante: {
        primario: "bg-tinta text-tinta-inversa hover:bg-tinta-2",
        acento: "bg-naranja text-white hover:brightness-95",
        secundario: "bg-fondo-alzado text-tinta hover:bg-fondo-suave",
        contorno: "border border-linea-fuerte bg-transparent text-tinta hover:bg-fondo-suave",
        fantasma: "bg-transparent text-tinta hover:bg-fondo-suave",
        liga: "bg-transparent text-azul underline-offset-4 hover:underline px-0 h-auto",
        peligro: "bg-rojo text-white hover:brightness-95",
      },
      tamano: {
        sm: "h-8 px-3 text-xs",
        md: "h-10 px-4",
        lg: "h-12 px-6 text-base",
        icono: "size-10",
      },
    },
    defaultVariants: { variante: "primario", tamano: "md" },
  },
);

export interface BotonProps
  extends React.ButtonHTMLAttributes<HTMLButtonElement>, VariantProps<typeof variantes> {
  /** Renderiza el hijo como elemento raíz (para <a> o <Link>). */
  asChild?: boolean;
}

export const Boton = React.forwardRef<HTMLButtonElement, BotonProps>(
  ({ className, variante, tamano, asChild = false, ...props }, ref) => {
    const Comp = asChild ? Slot : "button";
    return <Comp ref={ref} className={cn(variantes({ variante, tamano }), className)} {...props} />;
  },
);
Boton.displayName = "Boton";
export { variantes as variantesBoton };
